<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <fuse-alert
        *ngIf="showAlert"
        class="fixed z-50 top-4 right-5"
        [appearance]="'border'"
        [dismissible]="false"
        [showIcon]="true"
        [type]="alert.type"
        @fadeInRight>
        {{ alert.message }}
    </fuse-alert>
    <div class="flex flex-col gap-3 md:items-center md:flex-row">
        <div class="relative flex items-center">
            <button
                class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
                (click)="goback()">
                <mat-icon
                    class="w-[5px] mr-[1px] h-[3px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                    svgIcon="icons:arrow-icon">
                </mat-icon>
            </button>
            <h1 class="text-primary-black-01 title-6 md:title-3">{{ carpeta.RAZON_SOCIAL }}</h1>
        </div>
    </div>
    <div class="flex flex-col gap-1 mt-3 md:flex-row md:gap-5 text-primary-black-01 md:mt-0">
        <p class="title-9">Rut: {{ carpeta.RUTDV }}</p>
        <p class="title-9">Cuenta financiera: {{ carpeta.CUENTA_FINANCIERA }}</p>
        <p class="title-9">Folio: {{ carpeta.FOLIO }}</p>
    </div>

    <div class="my-5">
        <file-upload
            (fileEvent)="setFileInfo($event)"
            [returnFileBase64String]="false"
            [aceptedTypes]="fileUploadAceptedTypes"
            [icon]="'icons:cloud-icon'"
            [placeholder]="fileUploadPlaceholder"
            [maxFileSize]="'5MB'"
            #fileUpload>
        </file-upload>
    </div>

    <mat-form-field appearance="fill" class="w-full">
        <mat-label>Selecciona tipo de archivo</mat-label>
        <mat-select class="h-[54px]" [(ngModel)]="tipoSelected" [disabled]="fileUploading">
            <mat-option *ngFor="let adjunto of respuestaAdjuntos" [value]="adjunto.VALOR">
                {{ adjunto.VALOR || 'Seleccione' }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <button
        mat-flat-button
        color="primary"
        class="w-full mt-5 text-lg md:w-48 title-9"
        (click)="subirArchivo()"
        [disabled]="tipoSelected == '' || !file.status || fileUploading || respuestaDocumentos.length >= 8">
        <span *ngIf="!fileUploading"> Subir </span>
        <mat-progress-spinner *ngIf="fileUploading" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
    </button>

    <h2 class="mt-5 title-8">Documentos</h2>
    <div class="flex flex-wrap py-5 gap-x-7 gap-y-5">
        <div
            *ngFor="let documento of respuestaDocumentos; let i = index"
            class="rounded-xl w-full md:w-[190px] h-[112.04px] shadow-[0_5px_15px_2px_rgba(0,0,0,0.1)] flex flex-col justify-between pl-6 pr-4 py-6">
            <div class="flex justify-between w-full">
                <p class="font-extrabold paragraph-4 text-primary-black-01">
                    {{ documento.TIPO_ADJUNTO }}
                </p>
                <mat-icon class="w-[20.63px] h-[26.26px] min-w-[20.63px] min-h-[26.26px] text-primary" svgIcon="icons:pagares-icon"> </mat-icon>
            </div>

            <p class="font-extrabold cursor-pointer paragraph-5 text-primary-blue-01" (click)="descargarDocumento(documento)">Descargar</p>
        </div>
    </div>

    <form #formInfoPagare="ngForm">
        <h2 class="mt-5 title-8">Información pagaré</h2>
        <mat-form-field appearance="fill" class="w-full mt-2.5">
            <mat-label>Estado</mat-label>
            <mat-select class="h-[54px]" [(ngModel)]="estadoSelected" #estado="ngModel" name="estado" (selectionChange)="desactivar($event.value)">
                <mat-option *ngFor="let estado of estadosPagare" [value]="estado.ID_ESTADO">
                    {{ estado.NOMBRE_ESTADO || 'Seleccione' }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="estadoSelected === 9" hideRequiredMarker appearance="fill" class="w-full mt-2.5">
            <mat-label>Motivo anulación</mat-label>
            <mat-select class="h-[54px]" [(ngModel)]="motivoSelected" #motivo="ngModel" name="motivo" required>
                <mat-option *ngFor="let motivo of motivosAnulacion" [value]="motivo.VALOR">
                    {{ motivo.VALOR || 'Seleccione' }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full mt-1 example-full-width" appearance="fill">
            <mat-label>Comentario</mat-label>
            <textarea
                matInput
                [(ngModel)]="Comentario"
                #comentario="ngModel"
                name="comentario"
                class="h-24"
                maxlength="100"
                placeholder="Ingrese su comentario aquí"></textarea>
        </mat-form-field>
        <div class="flex flex-col md:flex-row md:gap-5">
            <mat-form-field class="w-full mt-1">
                <mat-label>N° de rol </mat-label>

                <input
                    [disabled]="rolDisabled"
                    class="h-[26px]"
                    matInput
                    placeholder="123"
                    value=""
                    maxlength="20"
                    type="text"
                    [(ngModel)]="Rol"
                    [patterns]="customPatterns"
                    [dropSpecialCharacters]="false"
                    mask="0*"
                    #rol="ngModel"
                    name="rol" />
            </mat-form-field>
            <mat-form-field class="w-full mt-1 fuse-mat-emphasized-affix">
                <mat-label>Monto recaudado</mat-label>
                <input
                    [disabled]="isDisabled"
                    [(ngModel)]="montoRecaudado"
                    class="h-[26px]"
                    type="text"
                    maxlength="20"
                    matInput
                    placeholder="1"
                    #monto_recaudado="ngModel"
                    name="monto_recaudado"
                    min="0"
                    [max]="montoRecaudadomaxValue"
                    [dropSpecialCharacters]="false"
                    mask="0*" />
                <span matPrefix>$</span>
            </mat-form-field>
        </div>
        <p class="mt-5 font-bold paragraph-1">
            Monto total: <span class="font-normal">$ {{ carpeta.MONTO_TOTAL | number: '1.0-9':'es-CL' }} {{ carpeta.ADJUNTO_PAGARE }} </span>
        </p>
        <button
            [disabled]="guardoCambio || estadoSelected == 0 || !formInfoPagare.valid"
            mat-flat-button
            color="primary"
            (click)="guardarCambio()"
            class="w-full my-5 text-lg md:w-48 title-9">
            <span *ngIf="!guardoCambio"> Guardar</span>
            <mat-progress-spinner *ngIf="guardoCambio" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
        </button>
    </form>
    <p class="my-5 font-bold paragraph-1">Historial</p>

    <app-mat-custom-table
        [use_selection]="false"
        [use_detail]="false"
        [dataset]="dataSourceAudit"
        [columns]="columns"
        [showPaginator]="false">
    </app-mat-custom-table>
</main>

<div *ngIf="showModalDetail" class="fixed inset-0 grid w-full h-full py-5 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div
        class="w-full max-w-[900px] h-full max-h-[700px] bg-primary-white-01 rounded-2xl px-10 py-10 md:px-10 md:py-12 gap-5 relative overflow-y-scroll no-scrollbar">
        <button
            class="absolute top-3 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="closeModalDetalle()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>

        <div class="flex flex-col items-center w-full p-4 overflow-y-scroll border rounded-lg border-primary-blue-01 no-scrollbar">
            <p class="title-8 text-primary-black-01">Datos</p>
            <p class="mt-1 break-all paragraph-5 text-primary-black-01">{{ detalleNuevo }}</p>
        </div>
    </div>
</div>
